import { useNavigate, useParams, useLocation } from "react-router-dom";
import { lang } from "src/language/Strings.js";
import { routes } from "src/routes";
import { useObjectType } from "src/api/hooks/useObjectType";
import { objectTypes } from "src/consts/objectTypes";

export function InspectionBottomComponent({
  className,
  overlays
}: {
  className?: string;
  overlays?: React.ReactNode;
}) {
  const { companyId, inspectionId } = useParams();
  const nav = useNavigate();
  const location = useLocation();
  const objectTypeItem = useObjectType();

  return (
    <div
      className={`border-t-2 border-Grey4 bg-White h-24 flex-shrink-0 w-full flex flex-row justify-between 
        items-center px-2 ${className || ""}`}
    >
      {overlays}
      <button
        type="button"
        onClick={() => {
          if (objectTypeItem.objectType === objectTypes.Deviation) {
            nav(routes.Deviation.Pages.Create.url(companyId));
          } else {
            nav(routes.Egenkontroller.Pages.Create.url(companyId));
          }
        }}
        className="inline-flex flex-col items-center justify-center px-3 hover:bg-gray-50 dark:hover:bg-gray-800 group h-full transition-all duration-150 ease-in-out hover:scale-105 active:scale-95 active:opacity-70"
      >
        <i
          className={`fa-plus fa-solid text-lg ${
            location.pathname.startsWith(
              routes.Egenkontroller.Pages.Create.url(companyId) ||
                routes.Deviation.Pages.Create.url(companyId)
            )
              ? "text-SkaneGreen"
              : "text-PrimaryGreen"
          }`}
        />
        <span className="text-xs group-hover:text-blue-600 dark:group-hover:text-blue-500">
          {lang.create}
        </span>
      </button>
      <button
        type="button"
        onClick={() => {
          if (objectTypeItem.objectType === objectTypes.Deviation) {
            nav(
              routes.Deviation.Pages.List.url(
                companyId,
                objectTypeItem.id ? String(objectTypeItem.id) : undefined
              )
            );
          } else {
            nav(
              routes.Egenkontroller.Pages.List.url(
                companyId,
                objectTypeItem.id ? String(objectTypeItem.id) : undefined
              )
            );
          }
        }}
        className="inline-flex flex-col items-center justify-center px-3 hover:bg-gray-50 dark:hover:bg-gray-800 group h-full transition-all duration-150 ease-in-out hover:scale-105 active:scale-95 active:opacity-70"
      >
        <i
          className={`fa-list fa-solid ${
            location.pathname.startsWith(
              routes.Egenkontroller.Pages.List.url(
                companyId,
                objectTypeItem.id ? String(objectTypeItem.id) : undefined
              )
            ) ||
            location.pathname.startsWith(
              routes.Deviation.Pages.List.url(
                companyId,
                objectTypeItem.id ? String(objectTypeItem.id) : undefined
              )
            )
              ? "text-SkaneGreen"
              : "text-PrimaryGreen"
          }`}
        />
        <span className="text-xs text-gray-500 dark:text-gray-400 group-hover:text-blue-600 dark:group-hover:text-blue-500">
          {objectTypeItem.objectType === objectTypes.Deviation
            ? lang.deviations
            : lang.egenkontrollerTitle}
        </span>
      </button>
      <button
        type="button"
        onClick={() => {
          if (objectTypeItem.objectType === objectTypes.Deviation) {
            nav(
              routes.Deviation.Pages.Show.url(
                companyId,
                objectTypeItem.id ? String(objectTypeItem.id) : undefined
              )
            );
          } else {
            nav(
              routes.Egenkontroller.Pages.Show.url(
                companyId,
                objectTypeItem.id ? String(objectTypeItem.id) : undefined
              )
            );
          }
        }}
        disabled={!objectTypeItem.id}
        className={`inline-flex text-lg flex-col items-center justify-center px-3 hover:bg-gray-50 dark:hover:bg-gray-800 group h-full disabled:opacity-50 transition-all duration-150 ease-in-out hover:scale-105 active:scale-95 active:opacity-70`}
      >
        <i
          className={`fa-receipt fa-solid ${
            !inspectionId
              ? "text-Grey4"
              : location.pathname.startsWith(
                  routes.Egenkontroller.Pages.Show.url(
                    companyId,
                    objectTypeItem.id
                  )
                ) ||
                location.pathname.startsWith(
                  routes.Map.url(
                    companyId!,
                    objectTypeItem.id ? String(objectTypeItem.id) : undefined
                  )
                )
              ? "text-SkaneGreen"
              : "text-PrimaryGreen"
          }`}
        />
        <span className="text-xs text-gray-500 dark:text-gray-400 group-hover:text-blue-600 dark:group-hover:text-blue-500">
          {lang.displayItem}
        </span>
      </button>
      <button
        type="button"
        onClick={() => {
          nav(
            routes.Map.url(
              companyId!,
              objectTypeItem.id ? String(objectTypeItem.id) : undefined
            )
          );
        }}
        className="inline-flex flex-col items-center justify-center px-3 hover:bg-gray-50 dark:hover:bg-gray-800 group transition-all duration-150 ease-in-out hover:scale-105 active:scale-95 active:opacity-70"
      >
        <i
          className={`fa-map fa-solid ${
            location.pathname.startsWith(routes.Map.url(companyId!, undefined))
              ? "text-SkaneGreen"
              : "text-PrimaryGreen"
          }`}
        />
        <span className="text-xs text-gray-500 dark:text-gray-400 group-hover:text-blue-600 dark:group-hover:text-blue-500">
          {lang.map}
        </span>
      </button>
      <button
        type="button"
        onClick={() => {
          nav(
            routes.SignOut.url()
          );
        }}
        className="inline-flex flex-col items-center justify-center px-3 hover:bg-gray-50 dark:hover:bg-gray-800 group transition-all duration-150 ease-in-out hover:scale-105 active:scale-95 active:opacity-70"
      >
        <i
          className={`fa-sign-out fa-solid ${
            location.pathname.startsWith(routes.SignOut.url())
              ? "text-SkaneGreen"
              : "text-PrimaryGreen"
          }`}
        />
        <span className="text-xs text-gray-500 dark:text-gray-400 group-hover:text-blue-600 dark:group-hover:text-blue-500">
          {lang.signOut}
        </span>
      </button>
    </div>
  );
}
